import EntityImageActions from '../../entityImage/EntityImageActions';

const RisqueImageActions = () => <EntityImageActions entityType="risk" />;

export default RisqueImageActions;
